<div class="container single-view" id="view-business-group">
  <div class="row">
    <div class="col-12 mb-4 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/business-groups" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'BUSINESS_GROUPS.BTN_BACK_TO_BUSINESS_GROUP' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-baseline justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="businessgroup-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'BUSINESS_GROUP_SINGLE_VIEW.BUSINESS_GROUP_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (businessGroup.name) {
                  <span data-testid='businessgroup-name'>{{ businessGroup.name | defaultValue }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyBusinessGroup) {
              <button data-testid='businessgroup-edit-btn' class="btn primary-btn" (click)="goToEditBusinessGroup()">{{ 'BUSINESS_GROUP_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }
            @if (delete) {
              <button data-testid='businessgroup-delete-btn' class="btn red-btn" (click)="showDeleteDialog()">{{'BUSINESS_GROUPS.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <h4 data-testid='businessgroup-details'>{{ 'BUSINESS_GROUP_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">
                  <dt data-testid='businessgroup-name-label' class="label grid-cols-1 pt-3">{{ 'BUSINESS_GROUP_SINGLE_VIEW.NAME' | translate }}</dt>
                  <dd data-testid='businessgroup-name' class="value pt-3 pb-3">{{ businessGroup.name | defaultValue }}</dd>

                  <dt data-testid='businessgroup-code-label' class="label grid-cols-1 pt-3">{{ 'BUSINESS_GROUP_SINGLE_VIEW.CODE' | translate }}</dt>
                  <dd data-testid='businessgroup-code' class="value pt-3 pb-3">{{ businessGroup.code | defaultValue }}</dd>
                </dl>
              </div>
            </section>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete business group -->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_BUSINESS_GROUP'" (onClose)="deleteBusinessGroup($event)"></dialog-reason>
